import PropTypes from 'prop-types'

import { sanityExternalLinkPropTypes } from './externalLink'
import { sanityInternalLinkPropTypes } from './internalLink'
import { sanityLibraryLinkPropTypes } from './libraryLink'
import { sanityPathLinkPropTypes } from './pathLink'

export const sanityLinkPropTypes = {
  target: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape(sanityInternalLinkPropTypes),
      PropTypes.shape(sanityExternalLinkPropTypes),
      PropTypes.shape(sanityPathLinkPropTypes),
      PropTypes.shape(sanityLibraryLinkPropTypes),
    ]),
  ),
}

export type SanityLinkProps = PropTypes.InferProps<typeof sanityLinkPropTypes>
